// ANCHOR React
import React from 'react';

// ANCHOR Base
import { styled } from 'baseui';

// ANCHOR Styles
import { BADGE, BadgeColor } from './styles';

const Badge = styled('div', BADGE);

interface IImageBadgeProps {
  color: BadgeColor;
  children: React.ReactNode;
}

export const ImageBadge = ({ color, children }: IImageBadgeProps) => (
  <Badge color={color}>
    {children}
  </Badge>
);
